export enum Nationality {
  Iranian = "iranian",
  Foreign = "foreign"
}

export enum Gender {
  Male = "Mr",
  Female = "Ms"
}

export type PassengerStoreType = {
  firstName?: string;
  lastName?: string;
  gender?: string;
  nationality?: string;
  nationalId?: string;
  passportNumber?: string;
  passportIssuePlace?: string;
  passportExpirationDate?: string;
  id?: string;
  birthdate?: string;
};
